// extracted by css-extract-rspack-plugin
export default {"container":"v2itt","clickable":"zV6SJ"};